import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import analyticsService from '../../services/analyticsService';

/**
 * Minimal landing header: logo left, CTA right.
 * No nav links - just PrecisionTrader + Start trading for free.
 */
const LandingMinimalHeader = ({
  onCtaClick,
  brandPathname = '/landing',
  ctaHref = '/register',
  ctaLabel = 'Start trading for free',
}) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const ctaUrl = ctaHref;
  const brandTo = { pathname: brandPathname, search: location.search, hash: location.hash || '' };

  const handleClick = () => {
    if (!user) {
      try {
        sessionStorage.setItem('registration_redirect', '/pricing');
      } catch (e) { /* ignore */ }
    }
    analyticsService.trackTradingEvent?.('cta_button_clicked', {
      variant: 'landing-header',
      user_id: user?.id || null,
      is_logged_in: !!user,
    });
    onCtaClick?.();
  };

  return (
    <header className="landing-minimal-header">
      <div className="landing-minimal-header-inner">
        <Link
          to={brandTo}
          className="landing-minimal-logo"
          onClick={() => window.scrollTo(0, 0)}
        >
          <img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="PrecisionTrader" />
          <span>PrecisionTrader</span>
        </Link>
        <Link
          to={ctaUrl}
          className="landing-minimal-cta"
          onClick={handleClick}
        >
          {ctaLabel}
        </Link>
      </div>
    </header>
  );
};

export default LandingMinimalHeader;
